// Wortlaute der Erklärung „Materialien“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Felder stehen so, wie die Materialseite sie zeigt (../material.js).
// Zwillingsdatei: help/machines.js. Was hier geändert wird, gehört fast immer auch dorthin.
export default {
  title: "Materialien",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    MaterialOverview: "Übersicht",
    MaterialDetail: "Material",
    CustomerDetail: "Kundenpreise",
    PacketDetail: "Paket",
    ProjectDetail: "Projekt",
    ProjectCostsForOne: "Projektkosten",
  },
  // Die Seiten außerhalb des Katalogs, in denen ein Material wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier steht der Materialkatalog Ihres Betriebs. Ein Klick auf eine Zeile öffnet das Material.",
    },
    row: {
      text: "Die Zeile zeigt Bezeichnung, Einkaufspreis je Einheit und wann das Material zuletzt geändert wurde.",
    },
    create: {
      text: "Neu anlegen bietet beides an: Neues Material erstellen öffnet das leere Formular. Es braucht Bezeichnung und Einheit.",
    },
    "kind-filter": {
      text: "Materialien und Pakete stehen in einer Tabelle, der Filter darüber zeigt nur eines von beiden. Ein Paket bündelt mehrere Materialien für Projekt und Kunde.",
    },
    head: {
      text: "Der Kopf trägt Symbol und Namen des Materials. Rechts stehen die Aktionen zu diesem Datensatz.",
    },
    "action-duplicate": {
      text: "Duplizieren öffnet ein neues Material mit denselben Angaben und Preisen. Sie ändern nur, was anders ist, und speichern.",
    },
    "action-packet": {
      text: "Paket daraus erstellen legt ein neues Paket an. Dieses Material steht darin schon als erste Position.",
    },
    tabs: {
      text: "Die Reiter teilen die Seite auf. Welcher Reiter offen ist, steht in der Adresse der Seite.",
    },
    base: {
      text: "Bezeichnung und Einheit sind die Stammdaten. Die Einheit rechnet in Projekten und Paketen mit, auch bei schon erfassten Mengen.",
    },
    purchase: {
      text: "Der Einkaufspreis gilt je Einheit. Wer bei verschiedenen Lieferanten unterschiedlich viel zahlt, legt mehrere Einkaufspreise mit Bezeichnung an; einer davon ist der Standard. Jeder Preis wählt seine eigene Währung, ein Projekt rechnet nur mit dem Preis in seiner Währung.",
    },
    note: {
      text: "Die Notiz ist für den internen Hinweis. Sie gehört zum Material und nicht zu einem einzelnen Projekt.",
    },
    // Der Reiter Einkauf, sobald die Einkaufspreise Lieferanten gehören (docs/suppliers.md).
    "purchase-tab": {
      text: "Im Reiter Einkauf steht jeder Lieferant, der dieses Material führt. Seine Preise ändern Sie beim Lieferanten im Sortiment.",
    },
    "purchase-history": {
      text: "Der Kopf nennt, was das Material in der Regel kostet: den Preis des Standard-Lieferanten und die Spanne über alle. Aufgeklappt zeigt der Preisverlauf jeden Preis über die Monate, rechts von Heute die schon feststehenden.",
    },
    "purchase-rows": {
      text: "Je Lieferant steht hier der Preis von heute und, wo schon eingetragen, der nächste. Abstand misst ihn am Standard, und der Name öffnet das Sortiment des Lieferanten.",
    },
    "purchase-default": {
      text: "Standard ist der Preis, mit dem ein Projekt das Material übernimmt. Ein Klick bei einem anderen Lieferanten macht ihn zum Standard, sofort und ohne Speichern.",
    },
    "purchase-change": {
      text: "Der Stift ändert den Preis eines Lieferanten: neuer Betrag, Staffeln und der Tag, ab dem er gilt, auch rückwirkend. Der alte Preis bleibt im Verlauf.",
    },
    "purchase-quantity": {
      text: "Mit einer Vergleichsmenge rechnet die Spalte Frei Baustelle Staffel, Rabatt, Fracht und Skonto ein. Bei „Abholung“ fällt die Fracht weg, die Spalte heißt dann Ab Lager. Der günstigste Preis steht fett und grün, auch wenn sein Listenpreis höher ist.",
    },
    "purchase-add": {
      text: "Preis hinzufügen nimmt den Preis eines weiteren Lieferanten auf. Der erste wird zum Standard.",
    },
    "purchase-object-prices": {
      text: "Unter einem Lieferanten stehen die Projekte, die bei ihm einen Objektpreis haben.",
    },
    "purchase-following": {
      text: "Nach einer rückwirkenden Änderung bleiben Buchungen der Projekte beim alten Preis. Umstellen bringt sie auf den Preis ihres Tages.",
    },
    files: {
      text: "In die Dateiablage legen Sie Datenblätter und Prüfberichte. Ein Ablaufdatum färbt sich, sobald es näher kommt.",
    },
    activity: {
      text: "Das Protokoll zeigt jede Änderung mit Tag und Person. Unter Verweise steht, wo dieses Material verwendet wird.",
    },
    save: {
      text: "Speichern schreibt alle Reiter auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    comparison: {
      text: "Über Aktionen und Vergleichen stellen Sie zwei Materialien nebeneinander. Die Zeilen sind die Lieferanten, die beide führen. Der günstigere Preis steht fett und grün.",
    },
    "comparison-pick": {
      text: "Oben in jeder Karte wählen Sie das Material. Darunter stehen sein üblicher Preis und bei wie vielen Lieferanten es das günstigere ist.",
    },
    "comparison-only": {
      text: "Lieferanten, die nur eines der beiden führen, stehen zugeklappt unter seiner Karte.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: was das Material außerhalb des Katalogs bewirkt.
    "customer-price": {
      text: "Für einen Kunden hinterlegen Sie einen eigenen Verkaufspreis, fest oder als Zuschlag auf den Einkaufspreis von hier.",
    },
    "packet-items": {
      text: "Ein Paket bündelt mehrere Materialien. Ein Projekt oder ein Kunde übernimmt sie damit in einem Schritt.",
    },
    "project-materials": {
      text: "Jede Buchung schreibt ihren Einkaufspreis fest. Die Projektkosten rechnen Menge mal diesem Preis.",
    },
    "project-report": {
      text: "Gebucht wird das Material im Reiter Materialien [[hwr:eines/einer/eines]] [[hwr.gen]], mit einer Menge je Tag. Zur Auswahl steht dort nur, was im Projekt hinterlegt ist.",
    },
    "project-costs": {
      text: "Die Kostenstruktur des Projekts zeigt, welcher Anteil der Kosten auf Material entfällt. Bewertet wird jede gebuchte Menge mit dem Einkaufspreis, der beim Speichern des Berichts festgeschrieben wurde.",
    },
  },
}
